import { ChartCurve } from '@base/@types/components/Layout/Graphic/Info'
import './Chart.css' // Arquivo CSS para customização

export const getStorageSeries = (data: any[]) => {
  return [
    {
      name: 'Estq Empresa R$',
      type: 'column',
      data: data.map(item => item.estoqueReaisAtual / 1000000)
    },
    {
      name: 'CMV R$',
      type: 'line',
      data: data.map(item => item.cmv / 1000000)
    },
    {
      name: ' Estq Empresa Dias',
      type: 'line',
      data: data.map(item => item.estoqueDiasAtual)
    }
    // {
    //   name: ' Empresa',
    //   type: 'line',
    //   data: data.map(item => item.empresaId),
    //   show: false
    // }
    // {
    //   name: ' Empresas',
    //   type: 'line',
    //   data: data.map(item => 0),
    //   show: false
    // }

    // {
    //   name: 'GMROI',
    //   type: 'line',
    //   data: data.map(item => item.estoqueDiasAtual)
    // }
  ]
}

export const storageOptions = (data: any[]) => {
  return {
    chart: {
      id: 'chart2',
      dropShadow: {
        enabled: true,
        color: '#000',
        top: 10,
        left: 7,
        blur: 8,
        opacity: 0.2
      },
      toolbar: {
        show: true,
        offsetY: -35,
        offsetX: -40
      }
    },
    fill: {
      type: 'solid',
      opacity: 1
    },
    colors: ['#1d5840', '#ecc94b', '#8e9aaf', '#2800b8'],

    stroke: {
      width: [5, 5, 5],
      dashArray: [0, 0, 5],
      curve: ChartCurve.smooth,
      markers: {
        size: 6 // Definido como 0 para não mostrar marcadores nas linhas inicialmente
      }
    },
    markers: {
      size: 0,
      hover: {
        sizeOffset: 6
      }
    },
    dataLabels: {
      enabled: !(data.length > 10),
      enabledOnSeries: [0, 1, 2],
      formatter: (val: number) => `${val.toFixed(1).replace('.', ',')}`
    },
    xaxis: {
      tickAmount: 10,
      labels: {
        rotate: 0
      },
      categories: data.map(item => {
        const month = new Date(item.data).getMonth() + 1
        const day = new Date(item.data).getDate()
        const year = new Date(item.data).getFullYear()
        const formattedDay = day <= 9 ? `0${day}` : day
        const formattedMonth = month <= 9 ? `0${month}` : month

        return `${formattedDay}/${formattedMonth}/${year}`
      })
    },
    yaxis: [
      {
        opposite: false,
        tickAmount: 3,
        labels: {
          show: true,
          formatter: (val: number) => `${val?.toFixed(0).replace('.', ',')}`
        }
      },
      {
        opposite: true,
        tickAmount: 2,
        labels: {
          show: false,
          formatter: (val: number) => `${val?.toFixed(0).replace('.', ',')}`
        }
      },
      {
        opposite: true,
        tickAmount: 2,
        labels: {
          show: true,
          formatter: (val: number) => `${val?.toFixed(0).replace('.', ',')}`
        }
      }
    ],
    legend: {
      show: true,
      position: 'top'
    },
    // tooltip: {
    //   shared: true,
    //   intersect: false,
    //   y: [
    //     {
    //       formatter: function (y: any) {
    //         const value = Number(y * 1000000).toFixed(0)
    //         return `R$ ${Number(value).toLocaleString('pt-BR')}`
    //       }
    //     },
    //     {
    //       formatter: function (y: any) {
    //         if (typeof y !== 'undefined') {
    //           const value = Number(y * 1000000).toFixed(0)
    //           return `R$ ${Number(value).toLocaleString('pt-BR')}`
    //         }
    //         return y
    //       }
    //     },
    //     {
    //       formatter: function (y: any) {
    //         return `${Number(y).toFixed(0).replace('.', ',')}`
    //       }
    //     }
    //     // {
    //     //   formatter: function (y: any, serie: any) {
    //     //     return (
    // // data[serie.dataPointIndex].empresaId +
    // // ' - ' +
    // // data[serie.dataPointIndex].empresaDescricao
    //     //     )
    //     //   }
    //     // }
    //   ]
    // }
    tooltip: {
      shared: true,
      // eslint-disable-next-line unused-imports/no-unused-vars
      custom: ({ series, seriesIndex, dataPointIndex, w }: any) => {
        // const hiddenSeriesData = this.state.hiddenSeries.data[dataPointIndex]; // Acessa os dados da série oculta
        return `
              <div class="tooltip" m="10">
                <span><b>Stk Emp R$ (Mi):</b> ${
                  series[0][dataPointIndex] != null
                    ? Number(series[0][dataPointIndex])
                        .toFixed(1)
                        .replace('.', ',')
                    : ''
                }</span><br/>
                <span><b>CMV R$:</b> ${
                  series[1][dataPointIndex] != null
                    ? Number(series[1][dataPointIndex])
                        .toFixed(1)
                        .replace('.', ',')
                    : ''
                }</span><br/>
                <span><b>Stk Emp Dias (Mi):</b> ${Number(
                  series[2][dataPointIndex]
                )
                  .toFixed(1)
                  .replace('.', ',')}</span><br/>
                    <span><b>Empresa :</b> ${
                      data[dataPointIndex].empresaId +
                      ' - ' +
                      data[dataPointIndex].empresaDescricao
                    }</span><br/>
              </div>
            `
      }
    }
  }
}

// export const storageOptionsLine = (data: any[]) => {
//   return {
//     chart: {
//       id: 'chart1',
//       brush: {
//         target: 'chart2',
//         enabled: true
//       },
//       selection: {
//         enabled: true
//       }
//     },
//     colors: ['#64a1d0'],
//     fill: {
//       type: 'solid',
//       opacity: [0.2, 1]
//     },
//     xaxis: {
//       tickAmount: 10,
//       labels: {
//         rotate: 0,
//         maxHeight: 24
//       },
//       categories: data.map(item => {
//         const month = new Date(item.data).getMonth()
//         const day = new Date(item.data).getDate()

//         return `${day}. ${getDescriptionMonth(month)}`
//       })
//     },
//     yaxis: {
//       show: false
//     },
//     legend: {
//       show: false
//     }
//   }
// }
